import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export default function useGetEmailsSuggestions({
  query,
  enabled = true,
}: {
  query: string;
  enabled?: boolean;
}) {
  return useQuery<Response<string[]>, CronoError>({
    queryKey: [ENDPOINTS.email.searchEmails, query],
    queryFn: ({ queryKey: [, query] }) => {
      const queryParams = queryString.stringify({ pattern: query });

      const request: Request = {
        url: `${ENDPOINTS.email.searchEmails}?${queryParams}`,
        config: {
          method: 'GET',
        },
      };

      return client(request);
    },
    enabled,
    keepPreviousData: true,
  });
}
